import React, { useState } from 'react';
import { useGeneration } from '../../contexts/GenerationContext';
import styles from './GenerationProgressBanner.module.css';

export default function GenerationProgressBanner() {
  const { activeJob, jobStatus, isGenerating, handleCancel, dismiss } = useGeneration();
  const [confirming, setConfirming] = useState(false);

  if (!activeJob || !jobStatus) return null;

  const { status, total, completed, currentLessonTitle } = jobStatus;
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

  if (status === 'completed' || status === 'cancelled' || status === 'failed') {
    return (
      <div className={styles.banner}>
        <div className={styles.info}>
          {status === 'completed' && (
            <p className={styles.completedText}>
              {completed} lessons generated for {activeJob.unitTitle}
            </p>
          )}
          {status === 'cancelled' && (
            <p className={styles.cancelledText}>
              Generation cancelled. {completed} of {total} lessons created for {activeJob.unitTitle}.
            </p>
          )}
          {status === 'failed' && (
            <p className={styles.cancelledText}>
              Generation failed. {completed} of {total} lessons created.
            </p>
          )}
        </div>
        <button className={styles.dismissBtn} onClick={dismiss}>
          Dismiss
        </button>
      </div>
    );
  }

  const onCancelClick = () => {
    if (!confirming) {
      setConfirming(true);
      return;
    }
    handleCancel();
    setConfirming(false);
  };

  return (
    <div className={styles.banner}>
      <div className={styles.spinner} />
      <div className={styles.info}>
        <p className={styles.title}>
          Generating lesson {completed + 1} of {total}
        </p>
        <p className={styles.subtitle}>
          {currentLessonTitle || activeJob.unitTitle}
        </p>
      </div>
      <div className={styles.progressBarTrack}>
        <div
          className={styles.progressBarFill}
          style={{ width: `${percent}%` }}
        />
      </div>
      <button className={styles.cancelBtn} onClick={onCancelClick}>
        {confirming ? 'Confirm cancel?' : 'Stop'}
      </button>
    </div>
  );
}
